import {Upload} from "antd";
import {showWarning} from "./notifications.helper";
import {fileExtension, fileExtensionFromType} from "constants/file.consts";
import i18next from "i18next";

// size - file size in KB, minSize - file size in B
export const beforeUpload = (
  file,
  formats = [fileExtension.PNG, fileExtension.PDF],
  size = 5120,
  minSize = 0
) => {
  const extensionFromType = fileExtensionFromType[file.type];
  const nameExtension = /\.(\w+)$/.exec(file.name)?.[1].toUpperCase();
  const isSuitableExtension = formats.includes(extensionFromType ?? nameExtension);
  !isSuitableExtension &&
    showWarning(i18next.t("FILE_UPLOAD_WRONG_TYPES").format(formats.join(", ")));

  const isLessThan = file.size / 1024 < size;
  !isLessThan &&
    showWarning(
      i18next.t("FILE_UPLOAD_TOO_LARGE_SIZE_MB").format(Math.round(size / 1024))
    );
  const isMoreThan = file.size > minSize;
  !isMoreThan && showWarning(i18next.t("FILE_UPLOAD_TOO_SMALL_SIZE_MB").format(minSize));

  return (isSuitableExtension && isLessThan && isMoreThan) || Upload.LIST_IGNORE;
};

export const formFilename = (name) =>
  (name || "")
    .replace(/[\\/:"*?<>|]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 100);
